import { v4 as uuidv4 } from 'uuid';

export default {
  props: {
    uuid: {
      type: String,
      default: () => uuidv4(),
      description: 'A unique id for identifying the component. If not provided as a prop, the id is autogenerated'
    }
  },
}